jQuery(document).ready(function($){

	//Side menu links

	$('.sidemenuLink').on('click', function(event){
		event.preventDefault();
		var anchorName = $(this).attr('href').replace('#', '');
		var aTag = $("a[name='"+ anchorName +"']");
    	$('html,body').animate({scrollTop: aTag.offset().top},'slow');
    	setActiveLink($(this));
	});



    $('.scrollSpyAnchorTitle').each(function(index, el){
    	
    	var elID = $(el).attr('id');
    	console.log(elID);
    	var minOffset = $(el).offset().top;
    	console.log(minOffset);
    	$('#' + elID).scrollspy({
    		min: minOffset,
    		onEnter: function(element, position) {
    			var currentAnchor = $('#anchor-' + elID);
    			var linkActiveID = currentAnchor.data('current');
    			var linkActive = $('#link' + linkActiveID);
                console.log('in', linkActive);
                setActiveLink(linkActive);
            },
            onLeave: function(element, position) {
                console.log('gone', element)
            }
	})
    });

	var currentActive;
	function setActiveLink(el){
		if ( el != currentActive ){
			scrolling = true;
			currentActive = el;
			$('.sideMenuLi').removeClass('active');
			el.parent().addClass('active');
		};
	}
});